import script from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"

import "./FullscreenSpin.vue?vue&type=style&index=0&id=3f5a457c&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5a457c"]])

export default __exports__